import Joyride from 'react-joyride';
import { useTour } from '../../shared/TourContext';
import { useLocation } from 'react-router-dom';

export default function TourRunner() {
  const { runTour, setRunTour, steps } = useTour();
  const location = useLocation();

  return (
      <Joyride
      key={`joyride-${location.pathname}`}
      steps={steps}
      run={runTour}
      continuous
      hideCloseButton={false}
      callback={(data) => {
        const { status, action } = data;
        
        if (
          status === "skipped" ||   
          status === "finished" ||  
          action === "close"        
        ) {
          setRunTour(false);
          
          console.log('Tour ended by:', action || status);
        }
      }}
      styles={{
        options: {
          overlayColor: 'rgba(0,0,0,0.5)',
        },
        buttonClose: {
          display: 'block', 
          color: '#0101FF', // company primary
        }
      }}
    />
  );
}